import React from 'react';
import { NavigationDots, SocialMedia } from '../components';
import { useTranslation } from 'react-i18next';

const AppWrap = (Component, idName, ClassNames) =>
  function HOC() {
    const { t } = useTranslation();
    return (
      <div id={idName} className={`app__container ${ClassNames}`}>
        <SocialMedia />

        <div className='app__wrapper app__flex'>
          <Component />

          <div className='copyright'>
            <p className='p-text'>{t('copyright')}</p>
            <p className='p-text'>{t('sanity-1')}</p>
          </div>
        </div>
        <NavigationDots active={idName} />
      </div>
    );
  };

export default AppWrap;
